---
de:
  contract:
    active: Aktiv
    counterpart: Vertragspartner
    end_date: Vertragsende
    errors:
      ownership_unscaled_on_shadow: Einspeisetarif- und Hedging-Verträge können keinem Schatten-Kraftwerk zugeordnet werden, das keinen Eigentumsanteil zur Aufteilung der gemeinsamen Produktion hat.
    open_ended: unbefristeter Vertrag
    power_plant: Kraftwerke
    power_plants: Kraftwerke
    start_date: Vertragsbeginn
    type: Vertragstyp
